import { LeftOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Form, Input, List, Radio, Row } from "antd";
import React, { useEffect, useState } from "react";
import {
  CHECKOUT_STEP,
  MINIMUM_PRICE_INSTALLMENT,
  PAYMENT_METHODS_NEED_VERIFY_OTP,
  PAYMENT_METHOD_COD,
  PAYMENT_METHOD_PAYOO_INSTALLMENT,
  ROUTER_PATH,
} from "../../common/constant";
import { IPaymentMethodProps } from "../../models/interface/IPaymentMethodProps";
import { localizeRouteKey, validatePhoneNumber } from "../../shared/helpers";
import { getPaymentMethods } from "../../services/payments";
import IPaymentMethod from "../../models/paymentMethodModel";
import { PaymentIcons } from "../../components/images";
import numeral from "numeral";
import _ from "lodash";
import shoppingCartService from "../../services/shoppingCart";
import Turnstile, { useTurnstile } from "react-turnstile";
import { CLOUDFLARE_SITE_KEY } from "../../utils/constant";

const PaymentMethod = (props: IPaymentMethodProps) => {
  const { history, t, gotoComplete, orderPrice, isRetryPayment } = props;
  const [form] = Form.useForm<any>();
  const [paymentMethods, setPaymentMethods] = useState<IPaymentMethod[]>([]);
  const [isRequsetInvoice, setIsRequestInvoice] = useState(false);
  const [currentMethod, setCurrentMethod] = useState(PAYMENT_METHOD_COD);
  const [captchaToken, setCaptchaToken] = useState<string | null>("");

  const turnstile = useTurnstile();

  const urlShippingInfo = localizeRouteKey(ROUTER_PATH.CHECKOUT, [
    t(CHECKOUT_STEP.SHIPPING_INFO),
  ]);
  const cartInfo: any = shoppingCartService.getShoppingCart();

  useEffect(() => {
    getPaymentMethods((cb) => {
      if (cb) {
        let data = cb.map((v) => {
          v.label = t(v.label);

          if (
            v.type === PAYMENT_METHOD_PAYOO_INSTALLMENT &&
            cartInfo &&
            cartInfo.items &&
            cartInfo.items.length
          ) {
            const totalInstallmentPrice = getTotalInstallmentPrice(
              cartInfo.items
            );

            v.label = v.label.replace(
              "$price",
              numeral(totalInstallmentPrice).format("0,0").replaceAll(",", ".")
            );
          }
          if (v.limit && v.limit > 0 && v.label) {
            v.label = v.label.replace("$limit", numeral(v.limit).format("0,0"));
          }
          return v;
        });
        setPaymentMethods(_.sortBy(data, ["order"]));

        if (props.paymentMethod) {
          form.setFieldsValue({ payment_method: props.paymentMethod });
        } else {
          const paymentMethod = data.find((x) => x.active);
          if (paymentMethod) {
            form.setFieldsValue({ payment_method: paymentMethod.type });
          }
        }
      }
    });
  }, []);

  const getTotalInstallmentPrice = (products: any) => {
    let totalInstallmentPrice = 0;

    products.forEach((item: any) => {
      if (isNaN(item.amount)) {
        totalInstallmentPrice += numeral(
          item.amount.replaceAll(".", ",")
        ).value();
      } else {
        totalInstallmentPrice += item.amount;
      }
    });

    return totalInstallmentPrice / 12;
  };

  const renderImagePaymentMethod = (paymentMethod: IPaymentMethod) => {
    return (
      <img
        src={_.get(PaymentIcons, paymentMethod.img)}
        className={"payment-method-icon"}
      />
    );
  };

  const renderHeaderInstallment = (
    <div className="header-installment sub-title">Trả góp</div>
  );

  const renderHeaderNotInstallment = (
    <div className="header-not-installment sub-title">Trả thẳng</div>
  );

  const onRequestInvoice = (e: any) => {
    setIsRequestInvoice(e.target.checked);
  };

  const onFinish = (values: any) => {
    if (gotoComplete) {
      let _values: any = {
        payment_method: {
          payment_method: values.payment_method,
        },
        token: captchaToken,
      };
      if (isRequsetInvoice) {
        _values = {
          ..._values,
          invoice_info: {
            full_name: values.full_name,
            invoice_address: values.invoice_address,
            invoice_receive_address: values.invoice_receive_address,
            phone_number: values.phone_number || "",
            tax_code: values.tax_code,
          },
        };
      }
      gotoComplete(_values);
    }
  };

  const checkValidInstallment = () => {
    if (
      !cartInfo ||
      cartInfo.number_total_amount < MINIMUM_PRICE_INSTALLMENT ||
      (orderPrice && orderPrice < MINIMUM_PRICE_INSTALLMENT)
    ) {
      return false;
    }

    return true;
  };

  const getInstallmentMethods = (methods: any) =>
    methods.filter(
      (item: any) => item.type === PAYMENT_METHOD_PAYOO_INSTALLMENT
    );

  const getMethodsNotInstallment = (methods: any) =>
    methods.filter(
      (item: any) => item.type != PAYMENT_METHOD_PAYOO_INSTALLMENT
    );

  const handleChangeRadio = (value: string) => {
    setCurrentMethod(value);
  };

  const checkComplete = () =>
    PAYMENT_METHODS_NEED_VERIFY_OTP.includes(currentMethod);

  const handleOnVerify = (token: string) => {
    setCaptchaToken(token);
  };

  const onHandleErrorTurnstile = (error: any) => {
    setCaptchaToken(null);
    turnstile?.reset();
  };

  return (
    <div className="payment-method">
      <h2>{t("payment_method_title")}</h2>
      <div className="form-payment-method">
        <Form
          layout={"vertical"}
          form={form}
          autoComplete="off"
          onFinish={onFinish}>
          <Form.Item
            required
            name="payment_method"
            rules={[
              {
                required: true,
                message: t("payment_method_valid"),
              },
            ]}>
            <Radio.Group
              style={{ width: "100%" }}
              size="large"
              onChange={(e) => handleChangeRadio(e.target.value)}>
              <List
                header={renderHeaderNotInstallment}
                bordered
                dataSource={getMethodsNotInstallment(paymentMethods)}
                className={"payment-method-items"}
                renderItem={(item: any) => (
                  <List.Item key={item.type} className={"payment-method-item"}>
                    <Radio value={item.type} checked={item.active}>
                      <div className={"label-wrapper"}>
                        {renderImagePaymentMethod(item)}
                        <span>{item.label}</span>
                      </div>
                    </Radio>
                  </List.Item>
                )}
              />
              {checkValidInstallment() ? (
                <List
                  header={renderHeaderInstallment}
                  bordered
                  dataSource={getInstallmentMethods(paymentMethods)}
                  className={"payment-method-items"}
                  renderItem={(item: any) => (
                    <List.Item
                      key={item.type}
                      className={"payment-method-item"}>
                      <Radio value={item.type} checked={item.active}>
                        <div className={"label-wrapper"}>
                          {renderImagePaymentMethod(item)}
                          <span>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.label,
                              }}></div>
                          </span>
                        </div>
                      </Radio>
                    </List.Item>
                  )}
                />
              ) : null}
            </Radio.Group>
          </Form.Item>
          {!isRetryPayment && (
            <Row className="kd-request-invoice-checkbox">
              <Checkbox onChange={onRequestInvoice}>
                <span>{t("request_invoice")}</span>
              </Checkbox>
            </Row>
          )}
          {isRequsetInvoice ? (
            <div>
              <Row align="middle" justify="space-between">
                <Col span={24}>
                  <Form.Item
                    required
                    className="kd-input-form"
                    label={t("company_name")}
                    name="full_name"
                    rules={[
                      {
                        required: true,
                        message: t("company_name_valid"),
                      },
                    ]}>
                    <Input placeholder={t("company_name")} />
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle" justify="space-between">
                <Col span={24}>
                  <Form.Item
                    className="kd-input-form"
                    label={t("customer_phone_number")}
                    name="phone_number"
                    rules={[
                      {
                        validator: (rule, value, callback) =>
                          validatePhoneNumber(value, callback, t),
                      },
                    ]}>
                    <Input placeholder={t("customer_phone_number")} />
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle" justify="space-between">
                <Col span={24}>
                  <Form.Item
                    required
                    className="kd-input-form"
                    label={t("field_tax_code")}
                    name="tax_code"
                    rules={[
                      {
                        required: true,
                        message: t("field_tax_code_valid"),
                      },
                    ]}>
                    <Input placeholder={t("field_tax_code")} />
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle" justify="space-between">
                <Col span={24}>
                  <Form.Item
                    required
                    className="kd-input-form"
                    label={t("field_address_invoice")}
                    name="invoice_address"
                    rules={[
                      {
                        required: true,
                        message: t("field_address_invoice_valid"),
                      },
                    ]}>
                    <Input placeholder={t("field_address_invoice")} />
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle" justify="space-between">
                <Col span={24}>
                  <Form.Item
                    initialValue={
                      (cartInfo &&
                        cartInfo.shipping_info &&
                        cartInfo.shipping_info.address &&
                        cartInfo.shipping_info.address.full_address) ||
                      ""
                    }
                    required
                    className="kd-input-form"
                    label={t("field_address_invoice_recevied")}
                    name="invoice_receive_address"
                    rules={[
                      {
                        required: true,
                        message: t("field_address_invoice_recevied_valid"),
                      },
                    ]}>
                    <Input placeholder={t("field_address_invoice_recevied")} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          ) : null}
          <Row justify="center" className="mb-16">
            <Turnstile
              sitekey={`${CLOUDFLARE_SITE_KEY}`}
              onSuccess={handleOnVerify}
              onError={onHandleErrorTurnstile}
              onExpire={onHandleErrorTurnstile}
              onTimeout={onHandleErrorTurnstile}
              theme="light"
              refreshExpired="auto"
            />
          </Row>
          <Row
            align="middle"
            justify="space-between"
            className="form-payment-method-footer">
            <Col>
              {!props.paymentMethod ? (
                <Button
                  type="link"
                  icon={<LeftOutlined />}
                  size={"large"}
                  className="back-shipping-info"
                  onClick={() => history?.replace(urlShippingInfo)}>
                  {t("back_shipping_info")}
                </Button>
              ) : null}
            </Col>
            <Col>
              <Button
                disabled={
                  !captchaToken ||
                  !(cartInfo.total_amount && cartInfo.total_amount != "0")
                }
                htmlType="submit"
                size={"large"}
                className="go-to-confirm-order kd-btn-primary-2 sub-title">
                {checkComplete()
                  ? t("submit_payment_method")
                  : t("continue_payment_method")}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default PaymentMethod;
